import { Component, input, InputSignal, output } from '@angular/core';
import {
  LocationDecisionAppEntityLocationDecisionWrite
} from '../../../../../../../openapi';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { AlertComponent } from '../../../../../../../common/alert/alert.component';

@Component({
  selector: 'app-location-decisions-preview',
  standalone: true,
  imports: [
    CommonModule,
    LabelComponent,
    AlertComponent
  ],
  templateUrl: './location-decisions-preview.component.html'
})
export class LocationDecisionsPreviewComponent {

  public showActions = input(false);

  public canEdit = input(true);

  public locationDecisions: InputSignal<LocationDecisionAppEntityLocationDecisionWrite[]> = input<LocationDecisionAppEntityLocationDecisionWrite[]>([]);

  public onRemove = output<number>();

  public onEdit = output<{ v: LocationDecisionAppEntityLocationDecisionWrite, i: number }>();

}
